export default __webpack_public_path__ + "static/media/stopIconAction.afef3d5d.svg";